import { nanoid as i } from "nanoid";
const r = [], a = (e) => {
  const n = i(5);
  return r.push({
    fn: e,
    id: n
  }), {
    removeEventListener: () => {
      const o = r.findIndex((t) => t.id === n);
      o > -1 && r.splice(o, 1);
    }
  };
}, c = {
  /**
   * Alerts the user to a message. This message is sent with a high priority
   *
   * @param message The message to send
   */
  alert: (e) => {
    r.forEach((n) => {
      n.fn("alert", e);
    });
  },
  /**
   * Informs the user of a message. This message is sent with a lower priority
   * @param message The message to send
   */
  inform: (e) => {
    r.forEach((n) => {
      n.fn("inform", e);
    });
  },
  /**
   * Clears all existing messages from the screen reader
   */
  clearAll: () => {
    r.forEach((e) => {
      e.fn("clearAll", "");
    });
  }
};
export {
  a as addListener,
  c as default
};
